import * as React from "react";

const SvgJob = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 700 700"
    style={{
      enableBackground: "new 0 0 700 700",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M238.7 85.5c-4.6 0-9.1 1.8-12.4 5.1-3.3 3.3-5.2 7.7-5.2 12.4v67.4H85.8c-4.3.4-8.3 2.5-11.2 5.7-2.9 3.2-4.5 7.4-4.5 11.8v100.9c0 36.5 28.2 65.9 67.5 86.9 35.3 18.9 84.2 30.3 137 37.1v-51c0-4.7 1.8-9.1 5.1-12.4 3.3-3.3 7.8-5.1 12.4-5.1h116c4.6 0 9.1 1.9 12.4 5.2 3.3 3.3 5.1 7.8 5.1 12.4v51c52.8-6.8 101.8-18.2 137.1-37.1 39.4-21.1 67.4-50.4 67.4-86.9V187.8c0-4.6-1.9-9-5.1-12.3s-7.7-5.1-12.3-5.1H478.9V103c0-4.6-1.8-9.1-5.1-12.3-3.3-3.3-7.7-5.1-12.3-5.1l-222.8-.1zm17.4 35h187.7v49.9H256.1v-49.9zm53.4 258.6v45.5h81v-45.5h-81zm302.4 6.1c-10.3 8.1-21.4 15.2-32.8 21.3-33.9 18.2-75.3 28-118.6 35.3v.1c-91.4 13.4-138.7 13.7-221 0v-.1c-43.2-7.3-84.5-17.1-118.5-35.3-11.4-6.1-22.5-13.2-32.8-21.2V575c0 4.6 1.8 9.1 5.1 12.4 3.3 3.3 7.7 5.2 12.4 5.2h488.8c4.6 0 9.1-1.9 12.4-5.2 3.3-3.3 5.1-7.8 5.1-12.4l-.1-189.8z" />
  </svg>
);

export default SvgJob;
